import { colors } from "@mui/material";

const white = "#FFFFFF";
const black = "#000000";
const padrao = {
  dark: colors.grey[500],
  main: colors.grey[300],
  light: colors.grey[100],
  contrastText: black,
};
const topbar = "#EB5757";

export default {
  black,
  white,
  padrao,
  topbar,
  primary: {
    contrastText: white,
    main: "#2196F3",
  },
  secondary: {
    contrastText: white,
    main: "#171C26",
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600],
  },
  background: {
    default: "#F4F6F8",
    paper: white,
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[300],
};
